<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container" (keydown)="keyDownFunction($event)">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="hasError">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{ error }}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <p><strong> Selected Plan : {{enrollment.PLANTYPENAME}}</strong></p>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <h2 class="head2-small mrg-10">Terms of Enrollment</h2>
        </div>
    </div>
    <div class="row" *ngIf="planYear2018">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    <strong>By completing this enrollment application, I agree to the following:</strong>
                </p>
                <p>
                    {{insuranceCompany}} serves a specific service area. If I move out of the area that {{insuranceCompany}} serves, I need to notify the plan so I can disenroll and find a new plan in my new area. I understand that I must use network pharmacies, except in an emergency when I cannot reasonably use {{insuranceCompany}} network pharmacies. Once I am a member of {{insuranceCompany}}, I have the right to appeal plan decisions about payment or services if I disagree. I will read the Evidence of Coverage document from {{insuranceCompany}} when I get it to know which rules I must follow to get coverage.
                </p>
                <p>I understand that if I leave this plan and don’t have or get other Medicare prescription drug coverage or creditable prescription drug coverage (as good as Medicare’s), I may have to pay a late enrollment penalty in addition to my premium for Medicare prescription drug coverage in the future. </p>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!planYear2018">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    <strong>By completing this enrollment application, I agree to the following:</strong>
                </p>
                <p>{{insuranceCompanyShortName}} PDP is a Medicare drug plan and has a contract with the Federal government. I understand that this prescription drug coverage is in addition to my coverage under Medicare; therefore, I will need to keep my Medicare Part A or Part B coverage. It is my responsibility to inform {{insuranceCompanyShortName}} of any prescription drug coverage that I have or may get in the future. I can only be in one Medicare Prescription Drug Plan at a time – if I am currently in a Medicare Prescription Drug Plan, my enrollment in {{insuranceCompanyShortName}} will end that enrollment. Enrollment in this plan is generally for the entire year. Once I enroll, I may leave this plan or make changes if an enrollment period is available, generally during the Annual Enrollment Period (October 15 – December 7), unless I qualify for certain special circumstances.</p>
                <p>
                    {{insuranceCompany}} serves a specific service area. If I move out of the area that {{insuranceCompany}} serves, I need to notify the plan so I can disenroll and find a new plan in my new area. I understand that I must use network pharmacies, except in an emergency when I cannot reasonably use {{insuranceCompany}} network pharmacies. Once I am a member of {{insuranceCompany}}, I have the right to appeal plan decisions about payment or services if I disagree. I will read the Evidence of Coverage document from {{insuranceCompany}} when I get it to know which rules I must follow to get coverage.
                </p>
                <p>I understand that if I leave this plan and don’t have or get other Medicare prescription drug coverage or creditable prescription drug coverage (as good as Medicare’s), I may have to pay a late enrollment penalty in addition to my premium for Medicare prescription drug coverage in the future. </p>
                <p>I understand that if I am getting assistance from a sales agent, broker, or other individual employed by or contracted with {{insuranceCompanyShortName}}, he or she may be paid based on my enrollment in {{insuranceCompanyShortName}}.</p>
                <p>Counseling services may be available in my state to provide advice concerning Medicare supplement insurance or other Medicare Advantage or Prescription Drug Plan options, medical assistance through the state Medicaid program, and the Medicare Savings Program.</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <h2 class="head2-small mrg-10">Release of Information:</h2>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p>
                    By joining this Medicare Prescription Drug Plan, I acknowledge that {{insComAetnaPdp}} will release my information to Medicare and other plans as is necessary for treatment, payment and health care operations. I also acknowledge that {{insuranceCompanyFullShort}} will release my information, including my prescription drug event data, to Medicare, who may release it for research and other purposes which follow all applicable federal statutes and regulations. The information on this enrollment form is correct to the best of my knowledge. I understand that if I intentionally provide false information on this form, I will be disenrolled from the plan.
                </p>
                <p><strong>By clicking the button below, the applicant certifies that the applicant has read, understands and agrees to the terms of enrollment and wishes to enroll with {{insuranceCompany}}</strong></p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-8">
            <div class="input-wrapper">
                <label>Application Received Date</label>
                <JQDatePicker [selectedDate]="enrollment.APPDT"
                              (elementClicked)="enrollment.APPDT = $event">
                </JQDatePicker>
            </div>
        </div>
        <div class="col-8">
            <div class="input-wrapper">
                <label>Effective Date of Enrollment</label>
                <JQDatePicker [selectedDate]="enrollment.EFFDT"
                              (elementClicked)="enrollment.EFFDT = $event"
                              [disabled]="disableEffectiveDate">
                </JQDatePicker>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">

                <label class="option">
                    <ValidatedCheckbox [id]="'beneficiary-has-signed-application'"
                                       [label]="'Beneficiary has signed application'"
                                       [checked]="enrollment.APPSIGNEDIND"
                                       (onValueChange)="onBeneficiarySignedChange($event)">
                    </ValidatedCheckbox>
                </label>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <ValidatedRadioButtonGroup [label]="'Does the Applicant have a legal guardian that is authorized to speak on his/her behalf?(Note: The Authorized Representative is NOT the Insurance Agent it is a person who has the power of attorney for the Applicant.)'"
                                           [options]="rblAuthorizedRep"
                                           [selectedValue]="enrollment.AUTHREPIND"
                                           (onValueChange)="rblAuthorizedRepClick($event)"
                                           [radioGroupName]="'rblAuthorizedRep'">
                </ValidatedRadioButtonGroup>
            </div>
        </div>
    </div>
    <div *ngIf="isAuthRep">



        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Name of authorized rep'"
                                        [text]="enrollment.AUTHREPNAME"
                                        (onValueChange)="enrollment.AUTHREPNAME = $event"
                                        [validators]="[notBlankValidator]">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Phone Number of authorized rep'"
                                        [text]="enrollment.AUTHREPPHONE"
                                        [maxlength]="10"
                                        (onValueChange)="enrollment.AUTHREPPHONE = $event"
                                        [validators]="[numericTextFieldValidator,lengthValidator]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="input-wrapper wide">
                    <ValidatedDropDown [label]="'Relationship to applicant'"
                                       [disabled]="'false'"
                                       [selectedValue]="enrollment.AUTHREPREL"
                                       (onValueChange)="enrollment.AUTHREPREL =$event"
                                       [options]="rblRelation">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Addresss of authorized rep'"
                                        [text]="enrollment.AUTHREPADD1"
                                        (onValueChange)="enrollment.AUTHREPADD1 = $event"
                                        [validators]="[notBlankValidator]">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'City'"
                                        [text]="enrollment.AUTHREPCITY"
                                        (onValueChange)="enrollment.AUTHREPCITY = $event"
                                        [validators]="[notBlankValidator]">
                    </ValidatedTextField>
                </div>
            </div>
            <div class="col-4">
                <div class="input-wrapper wide">
                    <ValidatedDropDown [selectedValue]="enrollment.AUTHREPST"
                                       [label]="'State'"
                                       [disabled]="'false'"
                                       (onValueChange)="enrollment.AUTHREPST  = $event"
                                       [options]="states"
                                       (blur)="onBlur()">
                    </ValidatedDropDown>
                </div>
            </div>
            <div class="col-4">
                <div class="input-wrapper">
                    <ValidatedTextField [label]="'Zip'"
                                        [text]="enrollment.AUTHREPZIP"
                                        (onValueChange)="enrollment.AUTHREPZIP = $event"
                                        [validators]="[notBlankValidator]" [maxlength]="5">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <div class="bottom-20">
                    <ValidatedRadioButtonGroup [label]="'Mail Copy of Materials to Authorized Representative'"
                                               [options]="rblMailCopy"
                                               [selectedValue]="enrollment.AUTHREPCOPYIND"
                                               (onValueChange)="enrollment.AUTHREPCOPYIND =$event"
                                               [radioGroupName]="'rblMailCopy'">
                    </ValidatedRadioButtonGroup>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-24">
                <div class="bottom-20">
                    <ValidatedCheckbox [id]="'cbxPOASignature'"
                                       [label]="'Power of Attorney has signed application'"
                                       [checked]="enrollment.AUTHREPSIGNEDIND"
                                       (onValueChange)="enrollment.AUTHREPSIGNEDIND= $event">
                    </ValidatedCheckbox>
                </div>
            </div>
        </div>

    </div>

    <indvrep [enrollmentindvrepViewModel]="enrollment"></indvrep>

    <div class="row">
        <div class="col-16">
            <div class="bottom-20">
                <p><strong>By clicking the button below, the applicant certifies that the applicant has read, understands and agrees to the terms of enrollment and wishes to enroll with {{insuranceCompany}}</strong></p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <div *ngIf="showTermsButton">
                <button class="button primary" (click)="formSubmit()">The Applicant has read and agrees to the Terms of Enrollment</button>
            </div>
            <button class="button primary" (click)="incompleteClick()">Save Incomplete Enrollment</button>
            <button class="button cancel" (click)="goBack()">Go Back</button>
        </div>
    </div>
</div>
